// app/providers.js
"use client";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { checkAndSetAnalyticsFromURL, shouldSkipAnalytics } from "./utils/analytics";

if (typeof window !== "undefined") {
  const AnalyticsEnabled = process.env.NEXT_PUBLIC_GA_ENABLED === "true";
  // Initialize PostHog only if analytics are enabled and not explicitly skipped
  if (AnalyticsEnabled && process.env.NEXT_PUBLIC_POSTHOG_KEY && !shouldSkipAnalytics()) {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
      capture_exceptions: true,
      capture_performance: {
        network_timing: true,
        web_vitals: true,
      },
      session_recording: {
        maskAllInputs: false,
        maskInputOptions: {
          password: true
        }
      }
    });
  }
}

export function PHProvider({
  children,
}: {
  children: React.ReactNode
}) {
  // Check for skipanalytics parameter in URL
  useEffect(() => {
    checkAndSetAnalyticsFromURL();
  }, []);

  const pathname = usePathname();

  useEffect(() => {
    if (pathname && posthog.__loaded) {
      posthog.capture("$pageview");
    }
  }, [pathname]);

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}